import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';

@Component({
  selector: 'app-dashboard-tab',
  templateUrl: './dashboard-tab.component.html',
  styleUrls: ['./dashboard-tab.component.scss']
})
export class DashboardTabComponent implements OnInit {

  constructor(
    public menu: MenuService
  ) { }

  ngOnInit(): void {
  }

}
